import { defineNuxtRouteMiddleware, navigateTo, useRequestEvent } from '#app'
import routers from '@/common/routers/routerList.js'

export default defineNuxtRouteMiddleware((to, from) => {
  let userAgent: string | undefined

  // 检查是否为服务端环境
  if (process.server) {
    // 获取当前请求的 event 对象
    const event = useRequestEvent()

    // 安全地获取 user-agent
    userAgent = event.node.req.headers['user-agent']
  }
  else {
    // 客户端获取 user-agent
    userAgent = navigator.userAgent
  }

  // 如果无法获取 user-agent，赋予默认值
  if (!userAgent)
    userAgent = ''

  // 判断是否为移动端
  const isMobile = /mobile/i.test(userAgent)
  if (isMobile) {
    const { name, params } = to
    const host = useRequestHeaders().host || '' // 获取域名信息
    if (host.includes('fccs.com')) {
      // fccs域名
      params.domain = host.split('.')[0]
      const route = routers.find(i => i.name === name)
      const mPath = typeof route?.mPath === 'function' ? route.mPath(params) : ''
      // PC端相关逻辑或进行重定向
      if (mPath)
        return navigateTo(mPath, { redirectCode: 301, external: true })
    }
  }
})
